document.addEventListener( 'DOMContentLoaded', function() {
    const container = document.querySelector('.before-after-comparison .slider-wrapper');
        if( container ) {
            document.querySelector('.before-after-comparison .slider').addEventListener('input', (e) => {
                container.style.setProperty('--position', `${e.target.value}%`);
            });
        }
});